import { siteNavigationComponent } from './js/siteNavigationComponent';
import { slickSlider } from './js/slickSlider';
import {testimonialSlider} from './js/testimonialSlider';
import { iconAnimation } from './js/iconAnimation';
import { stackcardsAnimation } from './js/stackcardsAnimation';


siteNavigationComponent();
testimonialSlider();
iconAnimation();

stackcardsAnimation();
